/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CameraAlt } from "@mui/icons-material";
import { Button, MobileStepper, Typography } from "@mui/material";
import React, { useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ExerciseSelectionForm from "../common/ExerciseSelectionForm";
import Active from "../images/active.svg";
import Bus from "../images/busStop.svg";
import Fitness from "../images/fitness.svg";
import PhysicalEducation from "../images/physicalEducation.svg";
import Queue from "../images/queue.svg";
import Waiting from "../images/waiting.svg";
import { pages } from "../pages/pages";
import { Settings } from "../types";
import { isTraditionalExerciseId } from "../utils/exercises";
import { setSettings } from "../utils/localStorage";
import { useFavouritesAndExcluded } from "../utils/useFavouritesAndExcluded";
import { ButtonContainer, CustomButton, FormContainer, ImageContainer, SecondaryButton, StyledImage } from "./Home.sc";

const Home: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);
    const shouldAutogenerate = useRef(false);
    const { favourites } = useFavouritesAndExcluded();
    const traditionalFavourites = useMemo(() => favourites.filter(isTraditionalExerciseId), [favourites]);

    const onSubmit = (values: Settings) => {
        setSettings(values);
        if (shouldAutogenerate.current) {
            navigate(pages.ai_exercise);
        } else {
            navigate(pages.exercise);
        }
    };

    const steps = [
        {
            text: t("appointment_waiting"),
            image: Waiting,
        },
        {
            text: t("use_your_time_active"),
            image: Fitness,
        },
        {
            text: t("bus_waiting"),
            image: Bus,
        },
        {
            text: t("use_your_time_active"),
            image: Active,
        },
        {
            text: t("queue_waiting"),
            image: Queue,
        },
        {
            text: t("use_your_time_active"),
            image: PhysicalEducation,
        },
    ];

    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            setActiveStep(0);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    // TODO: Move to stepper
    React.useEffect(() => {
        const timer = setTimeout(() => {
            handleNext();
        }, 5000);

        return () => clearTimeout(timer);
    });

    return (
        <>
            <FormContainer>
                <ImageContainer>
                    <StyledImage src={steps[activeStep].image} />
                </ImageContainer>
                <Typography textAlign={"center"}>{steps[activeStep].text}</Typography>
                <MobileStepper
                    variant="dots"
                    steps={steps.length}
                    position="static"
                    activeStep={activeStep}
                    sx={{ width: "100%", flexGrow: 1, marginBottom: "20px", justifyContent: "center", marginTop: "10px" }}
                    nextButton={null}
                    backButton={null}
                />
                <ExerciseSelectionForm
                    onSubmit={onSubmit}
                    favourites={traditionalFavourites}
                    buttons={(values) => (
                        <>
                            <ButtonContainer>
                                <CustomButton type="submit" variant="contained" disabled={values.categories.length === 0}>
                                    {t("start_exercises")}
                                </CustomButton>
                            </ButtonContainer>
                            <ButtonContainer>
                                <SecondaryButton
                                    onClick={() => {
                                        shouldAutogenerate.current = true;
                                    }}
                                    type="submit"
                                    variant="contained"
                                    endIcon={<CameraAlt />}
                                >
                                    {t("generate_ai")}
                                </SecondaryButton>
                            </ButtonContainer>
                        </>
                    )}
                />
            </FormContainer>
            <div style={{ display: "flex", width: "100%", padding: "0 40px 20px 40px", justifyContent: "center" }}>
                <Button style={{ textDecoration: "underline" }} onClick={() => navigate(pages.imprint)}>
                    {t("imprint")}
                </Button>
            </div>
        </>
    );
};

export default Home;
